module.exports = __webpack_public_path__ + "img/nl.ee8e1fd2.png";